import React, { CSSProperties, Fragment } from 'react';
type EditableTitleProps = {
  editable: boolean;
  text: string;
  handleChange:(event: React.ChangeEvent<HTMLInputElement>) => void;
  title: string;
  style?: CSSProperties;
}

const EditableTitle = ({ editable, text, handleChange, title, style}:EditableTitleProps) => {
  return (
    <Fragment>
      <div className="manage-p" style={style}>
        <p>{title}</p>
        <input type="text" placeholder={title} disabled={!editable}
                value={text ? text : ''} onChange={(event) => handleChange(event)}
                style={{fontWeight: !editable ? 'normal' : 'bold'}} />
      </div>
    </Fragment>
  );
};
export default EditableTitle;
